import { isSSR } from './ssr';

export const isIOS = !isSSR && /iPad|iPhone|iPod/.test(navigator.userAgent);
export const isTouchScreen = !isSSR && ('ontouchstart' in window || navigator.maxTouchPoints > 1);
